import { Flex } from '@abyss/web/ui/Flex';
import React from 'react';

import { ISquareBackgroundProps } from './types';

export const SquareBackground = ({
  fill,
  size,
  borderRadius,
  ...otherProps
}: ISquareBackgroundProps) => (
  <Flex
    {...otherProps}
    css={{
      width: size,
      height: size,
      backgroundColor: fill,
      borderRadius: borderRadius ?? 0,
    }}
  />
);
